// extracted by mini-css-extract-plugin
export var chip = "_ml-0";
export var icon = "_ml-1";
export var remove = "_ml-2";
export var removeIcon = "_ml-3";